module.exports = __webpack_public_path__ + "img/media-15.dbfe39a4.png";